module.exports = __webpack_public_path__ + "img/001bcab84488d8f9c63a4da11061b2e4.e67edf7f.png";